import React, { createContext, useContext, useState, useMemo } from "react";
import { translations } from "@/i18n";

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
  const initial = typeof window !== "undefined"
    ? localStorage.getItem("wedding_lang") || "es"
    : "es";
  const [lang, setLang] = useState(initial);

  const setLanguage = (next) => {
    setLang(next);
    try { localStorage.setItem("wedding_lang", next); } catch (_) {}
  };

  const value = useMemo(() => ({
    lang,
    setLang: setLanguage,
    t: translations[lang] || translations.es,
  }), [lang]);

  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
};

export const useLang = () => {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error("useLang must be inside LangProvider");
  return ctx;
};
